import { useEffect, useState } from "react";
import { rpc } from "@/lib/supabase";
import { PageHeader, Loader } from "@/components/kit";
import { AdminTable } from "@/components/AdminTable";
import { formatDateTime } from "@/lib/format";

export default function AdminBusinesses() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    rpc("admin_get_businesses").then((d) => setRows(d || [])).catch(() => setRows([]));
  }, []);
  if (rows === null) return <Loader />;
  const columns = [
    { key: "business_name", label: "Negocio", render: (r) => <span className="font-semibold text-white">{r.business_name || "—"}</span> },
    { key: "full_name", label: "Responsable" },
    { key: "phone", label: "Teléfono" },
    { key: "services_count", label: "Servicios" },
    { key: "created_at", label: "Registro", render: (r) => <span className="text-xs">{formatDateTime(r.created_at)}</span> },
  ];
  return (
    <div>
      <PageHeader title="Negocios" subtitle="Cuentas de negocio registradas." testId="admin-businesses" />
      <AdminTable columns={columns} rows={rows} testId="admin-businesses-table" empty="No hay negocios" />
    </div>
  );
}
